<template>
    <div>
        <div class="tips">
            <el-alert v-for="e in $store.state.errors" :key="e.key" :title="e.message" type="error" :closable="false"></el-alert>
        </div>
        <div class="qksmDiv" v-loading="loading">
            <qksm1 :T1="exprList['T1']" v-if="isData"></qksm1>
            <qksm2 :T2="exprList['T2']" v-if="isData"></qksm2>
            <qksm3 :T3="exprList['T3']" v-if="isData"></qksm3>
            <qksm4 :T4="exprList['T4']" v-if="isData"></qksm4>
            <qksm5 :T5="exprList['T5']" v-if="isData"></qksm5>
            <qksm6 :T6="exprList['T6']" v-if="isData"></qksm6>
            <qksm7 :T7="exprList['T7']" v-if="isData"></qksm7>
            <qksm8 :T8="exprList['T8']" v-if="isData"></qksm8>
            <qksm9 :T6="exprList['T6']" v-if="isData"></qksm9>
        </div>
    </div>
</template>
<script>
    import qksm1 from "@/components/22ys/qksmqinghai/qksm1.vue";
    import qksm2 from "@/components/22ys/qksmqinghai/qksm2.vue";
    import qksm3 from "@/components/22ys/qksmqinghai/qksm3.vue";
    import qksm4 from "@/components/22ys/qksmqinghai/qksm4.vue";
    import qksm5 from "@/components/22ys/qksmqinghai/qksm5.vue";
    import qksm6 from "@/components/22ys/qksmqinghai/qksm6.vue";
    import qksm7 from "@/components/22ys/qksmqinghai/qksm7.vue";
    import qksm8 from "@/components/22ys/qksmqinghai/qksm8.vue";
    import qksm9 from "@/components/22ys/qksmqinghai/qksm9.vue";
    import { getDivList, getPerformanceList } from "@/api/index.js";
    import { getBdata } from "@/api/zone.js";
    export default {
        name: "qksm",
        data() {
            return {
                loading: true,
                divname: "",
                qksm: {},
                exprList: {},
                tables: [],
                isData: false,
                errors: this.errors,
                errorType: false,
                typeText: '',
                isPdf: false,
            };
        },
        watch: {
            $route() {
                this.$store.commit("resetOrder");
                this.$nextTick(function () {
                    if (!this.loading) {
                        this.isChart()
                    }
                });
            },
        },
        async created() {
            if (this.$store.state.divData.queren == false) {
                this.$router.push({ name: "部门概况", query: { divid: this.$route.query.divid, sort: "one" }, });
            }
            this.$store.commit("resetOrder");
            await this.getDivData()
            this.$nextTick(function () {
                if (!this.loading) {
                    this.isChart()
                }
            });
        },
        methods: {
            async getDivData() {
                this.loading = true;
                let res = await getDivList({ id: this.$route.query.divid });
                res.attachments = await this.getAttachments()
                this.$store.commit('changeDivData', res)
                if (res.status == 0) {
                    this.divname = res.divname;
                    this.qksm = res.qksm;
                    this.tables = res.tables;
                    this.typeText = res.type == 0 ? "单位" : "部门";
                    let resBdata = await getBdata();
                    if (resBdata.status == 0) {
                        resBdata.bdata.forEach((e) => {
                            if (this.preview(e.expr).result) {
                                this.exprList[e.name] = this.preview(e.expr).result;
                            } else {
                                this.errorType = true
                            }
                        });
                        if (this.errorType) {
                            this.$message.error('数据异常!')
                        } else {
                            this.isData = true;
                        }
                        this.loading = false
                    }
                }

            },
            async getAttachments() {
                let list = []
                let nums = 1;
                let res = {}
                do {
                    res = await getPerformanceList({
                        id: this.$route.query.divid,
                        tags: "jxmbb,bmzxzj",
                        pageNumber: nums,
                        pageSize: 20,
                    });
                    list = list.concat(res.files);
                    nums++
                }
                while (res.files.length == 20)
                return list
            },
            preview(expr) {
                try {
                    let result = eval(this.makeEnvCode(this.tables) + expr);
                    return {
                        result,
                    };
                } catch (ex) {
                    return {
                        ex,
                    };
                }
            },
            isChart() {
                if (this.exprList["T2"].项目.filter((e) => e.value > 0).length > 0) {
                    document.getElementById("myChart2").style.display = 'block'
                    this.charts(
                        document.getElementById("myChart2"),
                        "图1：收入预算情况",
                        this.exprList["T2"].项目
                            .filter((e) => e.value > 0)
                            .map((e) => {
                                return {
                                    name: e.name,
                                    value: this.num(e.value).toFixed(2),
                                };
                            })
                    );
                }
                if (this.exprList["T3"].项目.filter((e) => e.value > 0).length > 0) {
                    document.getElementById("myChart3").style.display = 'block'
                    this.charts(
                        document.getElementById("myChart3"),
                        "图2：支出预算情况",
                        this.exprList["T3"].项目
                            .filter((e) => e.value > 0)
                            .map((e) => {
                                return {
                                    name: e.name,
                                    value: this.num(e.value).toFixed(2),
                                };
                            })
                    );
                }
                if (this.exprList["T4"].支出.filter((e) => e.value > 0).length > 0) {
                    document.getElementById("myChart4").style.display = 'block'
                    this.charts(
                        document.getElementById("myChart4"),
                        "图3：财政拨款收支预算情况",
                        this.exprList["T4"].支出
                            .filter((e) => e.value > 0)
                            .map((e) => {
                                return {
                                    name: e.name + '支出',
                                    value: this.num(e.value).toFixed(2),
                                };
                            })
                    );
                }
                if (this.num(this.exprList["T5"].总计) > 0) {
                    document.getElementById("myChart5").style.display = 'block'
                    this.barChart(
                        document.getElementById("myChart5"),
                        "图4：一般公共预算较上年变化情况",
                        [this.num(this.exprList["T5"].总计last), this.num(this.exprList["T5"].总计)])
                }
                if (this.exprList["T5"].leiItems.length > 0) {
                    document.getElementById("myChart6").style.display = 'block'
                    this.charts(
                        document.getElementById("myChart6"),
                        "图5：一般公共预算当年拨款规模变化",
                        this.exprList["T5"].leiItems
                            .map((e) => {
                                return {
                                    name: e.name,
                                    value: this.num(e.value).toFixed(2),
                                };
                            })
                    );
                }
            }
        },

        components: {
            qksm1,
            qksm2,
            qksm3,
            qksm4,
            qksm5,
            qksm6,
            qksm7,
            qksm8,
            qksm9,
        },
    };
</script>
<style>
    .el-textarea textarea {
        margin: 5px 0;
    }

    .qksm h4 {
        text-indent: 2em;
        font-size: 20px;
        line-height: 2.5em;
    }

    .qksm p {
        line-height: 2em;
        text-indent: 2em;
        font-family: FangSong;
        font-size: 20px;
    }

    .echart {
        width: 90%;
        height: 500px;
        border: 1px red solid;
        margin: 0 auto;
        padding: 10px;
        display: none
    }

    .loading, .qksmDiv {
        height: 100%;
    }
</style>